import React from 'react';
import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
} from '@material-ui/core';
import validar from './validar';


export default function FieldMasked (props) {
  const { MaskCmp, getValue, getError, name, label, setValue, setError, setTouch, valida, wasTouched } = props;
  const value = getValue(name);
  const error = getError(name);
  const hasError = Boolean(error);
  if (valida) validar({ name, valida, value, setError, wasTouched, hasError })
  return (
    <FormControl error={hasError}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Input
        value={value}
        onChange={setValue(name)}
        onBlur={setTouch(name)}
        id={name}
        inputComponent={MaskCmp}
      />
      {hasError && (
        <FormHelperText>{error}</FormHelperText>
      )}
    </FormControl>
  )
}
